/**
 * Problem: Currently, all the JSON codes are hardcoded and added as a files inside product code, as they are huge in size
 * the product is taking long time to build. (yarn build)
 *
 * Solution: Move all the static JSON files to the public folder and get those on demand.
 *
 * Steps to follow:
 * 1. Declare your JSON file name in the JSON_FILE_NAMES object.  // why? for better maintaince and for point 3 & 4
 *  1.1 - JSON_FILE_NAMES object structure
 *  {
 *    [yourKey]: fileName
 *  }
 * 2. While making the request (GET_CONSTANTS), pass the corresponding JSON_FILE_NAMES object key
 * 3. The JSON file Structure should be always in the below format:
 *  3.1 Filename -> fileName.json
 *  3.2 Content
 *  {
 *    [fileName] : yourDetails (array or object)
 *  }
 *  3.3 - The file should have only one parent key (which is equivalent to the fileName, and inside the key we can have any data)
 * 4. By following the above structure, it is better to memoize it and the GET_CONSTANTS function can handle all type on json file request
 * and return the correct details.
 *
 * Custom hook to get details.
 * 1. You can make as many as hooks and utilize the GET_CONSTANTS function based on the usecase
 */

import { useEffect, useState } from 'react';
import envConfig from '@nile/home/src/Config/env';

/* used for memoization */
const CONSTANTS_MEMOIZATION = {};

/* declare all your static json file here */
const JSON_FILE_NAMES = {
  states: 'states',
  country: 'country'
};

async function GET_CONSTANTS(file) {
  try {
    if (CONSTANTS_MEMOIZATION[file]) {
      return CONSTANTS_MEMOIZATION[file];
    }
    const response = await fetch(
      `${envConfig.public}/lib/${file}.json?version=${envConfig.staticFileVersion}`,
      {}
    );
    const details = await response.json();
    const constantsDetails = details[file] || [];
    CONSTANTS_MEMOIZATION[file] = constantsDetails;
    return constantsDetails;
  } catch (ex) {
    // console.error(ex);
  }
}

function useStateList(props) {
  const [states, setStates] = useState([]);
  useEffect(() => {
    const getStates = async () => {
      const statesList = await GET_CONSTANTS(JSON_FILE_NAMES[props]);
      setStates(statesList);
    };
    getStates();
  }, []);
  return states;
}
export { GET_CONSTANTS, useStateList };
